var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C11.624 15 15 11.6442 15 7.5C15 3.35579 11.624 0 7.5 0C3.37601 0 0 3.37601 0 7.5C0 11.624 3.37601 15 7.5 15ZM7.5 1.41509C10.8558 1.41509 13.5849 4.1442 13.5849 7.5C13.5849 10.8558 10.8558 13.5849 7.5 13.5849C4.1442 13.5849 1.41509 10.8558 1.41509 7.5C1.41509 4.1442 4.1442 1.41509 7.5 1.41509Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57963 10.4313L7.50011 8.51077L9.4206 10.4313L10.4314 9.42048L8.51089 7.49999L10.4314 5.57951L9.4206 4.56873L7.50011 6.48921L5.57963 4.56873L4.56885 5.57951L6.48933 7.49999L4.56885 9.42048L5.57963 10.4313Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.38e62aa7.svg";
export { ForwardRef as ReactComponent };